/* ** *** *** ***
Covetrus PCI/Security Notice:
This file has been identified as potentially impacting user and/or data security.
All modifications to these files must be reviewed and merged by a designated Security Champion for this application.
Additional information, including specifics for Pull Requests, can be found here:
https://dvmwiki.atlassian.net/wiki/spaces/MCT/pages/507511182/Code+Reviews
*** *** *** ** */

import _ from 'lodash';
import { AUTH_NET_TOKENIZATION, ORDER_BUTTON_CLICKED } from './types';

const RR_PRACTICE_PLATFORM_TYPE_ID = 6;

const onSuccessAuthNet = (dispatch, authNetPayment) => {
  dispatch({
    type: AUTH_NET_TOKENIZATION,
    payload: authNetPayment,
  });
};

const paymentFormUpdate = opaqueData => {
  const { dataDescriptor } = opaqueData;
  const { dataValue } = opaqueData;
  const nonce = { dataDescriptor, dataValue };
  return nonce;
};

export const orderButtonClicked = dispatch => {
  dispatch({
    type: ORDER_BUTTON_CLICKED,
  });
};

const responseHandler = response => {
  if (response.messages.resultCode === 'Error') {
    let i = 0;
    while (i < response.messages.message.length) {
      alert(
        response.messages.message[i].code &&
          ': ' &&
          response.messages.message[i].text
      );
      i += 1;
    }
  } else {
    const noncePayment = paymentFormUpdate(response.opaqueData);
    return noncePayment;
  }
  return null;
};

const sendPaymentDataToAnet = (
  defaultPaymentOption,
  customer,
  prescription,
  handlePlaceOrder,
  product,
  billingType,
  shipToType
) => dispatch => {
  orderButtonClicked(dispatch);

  const authData = {
    clientKey: _.isEqual(
      RR_PRACTICE_PLATFORM_TYPE_ID,
      customer.practicePlatformTypeId
    )
      ? RR_AUTH_CLIENTKEY
      : VPA_AUTH_CLIENTKEY,
    apiLoginID: _.isEqual(
      RR_PRACTICE_PLATFORM_TYPE_ID,
      customer.practicePlatformTypeId
    )
      ? RR_AUTH_APILOGINID
      : VPA_AUTH_APILOGINID,
  };

  const cardData = {
    cardNumber: defaultPaymentOption.creditCardNumber,
    month: defaultPaymentOption.expirationMonth,
    year: _.slice(
      defaultPaymentOption.expirationYear,
      defaultPaymentOption.expirationYear.length - 2
    ).join(''),
  };

  const secureData = { authData, cardData };

  return new Promise((resolve, reject) => {
    Accept.dispatchData(secureData, response => {
      if (response.messages.resultCode === 'Error') {
        reject(response);
      } else {
        resolve(response);
      }
    });
  })
    .then(responseHandler)
    .catch(responseHandler)
    .then(noncePayment => {
      if (!noncePayment) {
        return null;
      }
      onSuccessAuthNet(dispatch, noncePayment);
      const opaqueData = noncePayment;
      return opaqueData;
    })
    .then(opaqueData => {
      if (!opaqueData) {
        return null;
      }
      return handlePlaceOrder({
        customer,
        prescription,
        product,
        opaqueData,
        billingType,
        shipToType,
      });
    });
};

export default sendPaymentDataToAnet;



// WEBPACK FOOTER //
// ./src/actions/order/authNet.js